// @ts-nocheck
import * as React from "react";

const ArrowUpward: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="m12 2.98 6.346 6.347-.689.688L12.5 4.863V21h-1V4.883L6.342 10.04l-.689-.713L12 2.981Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(ArrowUpward);
